import type { RouteRecordRaw } from 'vue-router'
import { i18n } from '@/shared/i18n'

const { t } = i18n.global

export const InventoryGroupPages = {
  list: 'ListInventoryGroup',
  add: 'AddInventoryGroup',
  edit: 'EditInventoryGroup',
}

const title = t('pages.inventoryGroups')
const path = '/inventory-groups'
const breadcrumb = [{ title, path }]

const Add: RouteRecordRaw = {
  path: 'add',
  name: InventoryGroupPages.add,
  component: () => import('@/pages/mainPageWithRoute/inventory-group/AddInventoryGroupPage.vue'),
  meta: { title: t('actions.add'), requiresAuth: true, breadcrumb },
}

const Edit: RouteRecordRaw = {
  path: ':id',
  name: InventoryGroupPages.edit,
  component: () => import('@/pages/mainPageWithRoute/inventory-group/EditInventoryGroupPage.vue'),
  meta: { title: t('actions.edit'), requiresAuth: true, breadcrumb },
}

const List: RouteRecordRaw = {
  path: '',
  name: InventoryGroupPages.list,
  component: () => import('@/pages/mainPageWithRoute/inventory-group/ListInventooryGroupPage.vue'),
  meta: { title, requiresAuth: true },
}

export const InventoryGroups: RouteRecordRaw = {
  path,
  name: t('pages.inventoryGroups'),
  component: () => import('@/pages/mainPageWithRoute/MainPageWithRouterView.vue'),
  meta: { title, requiresAuth: true },
  children: [List, Add, Edit],
}
